import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from 'components/Auth';
import { AppConfigProvider, SnackbarProvider, RegionConfigProvider,
    TranslationsProvider, ThemeProvider, MomentProvider, ApolloProvider, ReactQueryProvider } from 'providers';
import { ScreenSizeProvider } from 'components/Layout';
import { TooltipProvider } from 'providers/Tooltip';
import { Spinner } from 'components/Shared';
import { enableMockServiceWorker } from './mocks/browser';

import './index.scss';

const elements = (
    <ThemeProvider>
        <Suspense fallback={<Spinner fillParent/>}>
            <AppConfigProvider>
                <RegionConfigProvider>
                    <SnackbarProvider>
                        <TranslationsProvider>
                            <ReactQueryProvider>
                                <AuthProvider>
                                    <ApolloProvider>
                                        <MomentProvider>
                                            <ScreenSizeProvider>
                                                <TooltipProvider>
                                                    <App/>
                                                </TooltipProvider>
                                            </ScreenSizeProvider>
                                        </MomentProvider>
                                    </ApolloProvider>
                                </AuthProvider>
                            </ReactQueryProvider>
                        </TranslationsProvider>
                    </SnackbarProvider>
                </RegionConfigProvider>
            </AppConfigProvider>
        </Suspense>
    </ThemeProvider>
);

async function bootstrap() {
    await enableMockServiceWorker();
    createRoot(document.getElementById('root')!).render(elements);
}

bootstrap();
